// Certificate service 5002
const CertificateService = '/certificate-management';
const CertificateController = `${CertificateService}/certificates`;

export const Certificate = {
    Certificates: CertificateController,
    CertificateId: (certificateId) => `${CertificateController}/${certificateId}`,
    TraineeCertificate: (certificateId, referenceId, referenceType) => `${CertificateController}/${certificateId}/trainee-certificate/${referenceType}/${referenceId}`,
    UploadCertificateBackground: (certificateId) => `${CertificateController}/${certificateId}/upload-certificate-background`,
    CertificateStatus: (certificateId, status) => `${CertificateController}/${certificateId}/${status}`,
};
